import { defaultTo } from 'lodash';
import { IModel, Model, ModelRecord } from '.';

export interface ISalesItemAttributeProcessingTypeModel extends IModel {
  salesItemAttributeProcessingTypeId: number;
  name: string;
}

export class SalesItemAttributeProcessingTypeModel
  extends Model
  implements ModelRecord<ISalesItemAttributeProcessingTypeModel>
{
  salesItemAttributeProcessingTypeId: number;
  name: string;

  constructor(params?: Partial<ISalesItemAttributeProcessingTypeModel>) {
    super(params);
    this.salesItemAttributeProcessingTypeId = defaultTo(
      params?.salesItemAttributeProcessingTypeId,
      0,
    );
    this.name = defaultTo(params?.name, '');
  }
}
